import { ColumnExport } from '@app/shared/export';
import { Identifier } from '@app/utils/common';
import { ConfigColumns } from 'datatables.net';

export type CustomColumnSettings = ConfigColumns & {
  /**
   * If a custom component has been defined then it will be created and attached to the column.
   */
  customComponent?: any;

  /**
   * Name of the property this column is based on.
   */
  data: string;

  /**
   * Settings that are used when exporting the data.
   */
  export: ColumnExport<any> | false;

  /**
   * Functions that indicates if the given object matches the search term.
   *
   * @param value Row object.
   * @param search Term to search for.
   */
  filter?: (value: any, search: string) => boolean;

  /**
   * If true, the column will be hidden automatically if the select mode is enabled.
   */
  hiddenInSelectMode: boolean;

  /**
   * If true, the visibility of the column can be toggled.
   */
  isOptional: boolean;

  /**
   * Function that is called after the column has been created.
   *
   * @param row Row object
   * @param instance Component instance
   */
  onAfterCreate?: (row, instance) => void;

  /**
   * Options that are passed to the datatables.net plugin.
   * See https://datatables.net/reference/option/columns for more information.
   */
  options?: ConfigColumns;

  /**
   * A function that returns a comparable value that is used for sorting.
   *
   * @param value
   */
  sort?: (value: any) => Identifier;

  visible: boolean;
};

export function isCustomComponent(column): column is CustomColumnSettings {
  return column.hasOwnProperty('customComponent') && column.customComponent !== undefined;
}
